import { render, staticRenderFns } from "./WPPageManagerPageNew.vue?vue&type=template&id=54f1ca7f&"
import script from "./WPPageManagerPageNew.vue?vue&type=script&lang=ts&"
export * from "./WPPageManagerPageNew.vue?vue&type=script&lang=ts&"
import style0 from "./WPPageManagerPageNew.vue?vue&type=style&index=0&id=54f1ca7f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports